export default {
    current_choice: 'Pašreizējā izvēle',
    book_now: 'Rezervēt tagad',
    minimum_age: 'Tikai vecākiem par {age} gadiem',
    excess_liability: 'Pašrisks',
    security_deposit: 'Drošības depozīts',
    fuel_policy: 'Degvielas politika',
    like_for_like: 'Tāds pats pret tādu pašu',
    full_to_full: 'Pilna līdz pilnai',
    miles_per_rental: '{mileage} bezmaksas jūdzes par nomu',
    km_per_rental: '{mileage} bezmaksas km par nomu',
    unlimited_mileage: 'Neierobežots nobraukums',
    unlimited_mileage_km: 'Neierobežoti km',
    non_amendable: 'Nav iespējams mainīt',
    non_refundable: 'Nav atmaksājams',
    free_cancellation_until: 'Bezmaksas atcelšana līdz',
    basic_free_cancellation: 'Bezmaksas atcelšana līdz 48 stundām pirms sākuma laika',
    cancellation_in_line_with: 'Atcelšana saskaņā ar',
    tcs: 'Noteikumi un nosacījumi',
    free_extras_on_collection: 'Divi bezmaksas papildinājumi saņemot',
    glass_and_tyres_covered: 'Stikli un riepas ir apdrošinātas',
    number_of_passengers: 'Pasažieru skaits',
    number_of_bags: 'Bagāžas daudzums',
    fuel_type: 'Degvielas veids',
    co2: 'CO2',
    aircon: 'Kondicionieris',
    transmission: 'Transmisija',
    book_type: 'Rezervēt {type}',
    debit_card_deposit: 'Pieņemta debetkarte depozītam',
    fast_track_included: 'Ātrā apkalpošana iekļauta',
    view_all: 'Skatīt visu',
};
